import React from 'react';
import { getDiceEntryRenderState, resolveFaceOverride } from './dice.logic';
import { DiceResultBadge, SourceAvatar, renderRollToken } from './dice.ui';

export const DiceDisplayHistory = ({
  history,
  historyLimit,
  historyScrollRef,
  animByRollKey,
  newestKey,
  lastSeenRollKey,
  mountedAt,
  animationMs,
  buttons,
  items,
  contextItem,
  item,
}) => {
  return (
    <div
      ref={historyScrollRef}
      className='h-full overflow-y-auto w-full board-grid-no-drag'
      onWheelCapture={e => e.stopPropagation()}
    >
      <div className='min-h-full flex flex-col justify-end gap-1 text-xs text-contrast text-opacity-70 px-02'>
        {history
          .slice(0, historyLimit)
          .slice()
          .reverse()
          .map((h, i) => {
            const rollKey = h?.rollId || h?.at || null;
            const anim = rollKey ? animByRollKey?.[rollKey] : null;
            const vm = getDiceEntryRenderState({
              entry: h,
              anim,
              now: Date.now(),
              newestKey,
              lastSeenRollKey,
              mountedAt,
              animationMs,
              buttons,
              items,
              contextItem,
              item,
            });

            return (
              <div
                key={`${vm.rollKey || h?.at || 't'}-${i}`}
                className='flex items-center justify-between gap-05'
              >
                <div className='text-contrast text-opacity-60 flex items-center gap-03 min-w-0'>
                  {vm.fromItemId && items?.[vm.fromItemId]?._id ? (
                    <SourceAvatar
                      item={items[vm.fromItemId]}
                      tooltip={vm.fromItemLabel || ''}
                    />
                  ) : null}
                  <DiceResultBadge
                    label={vm.resultLabel}
                    iconSlug={vm.resultIconSlug}
                    color={vm.resultColor}
                    description={vm.resultDescription}
                    itemId={vm.fromItemId || item?._id || null}
                    textId={`${vm.rollKey || h?.at || 'history'}-result`}
                  />
                </div>

                <div
                  className='flex-1 bg-avatar opacity-60 h-px'
                  style={{
                    '--avatar-color':
                      vm.avatarBgColor && vm.avatarBgColor !== 'transparent'
                        ? `var(--${vm.avatarBgColor})`
                        : 'var(--primary)',
                  }}
                />

                <div className='font-condensed text-right'>
                  {vm.displayMode === 'each' &&
                  (Array.isArray(vm.animRolls) ||
                    (Array.isArray(vm.rolls) && vm.rolls.length > 1)) ? (
                    <span className='flex items-center gap-03 flex-wrap justify-end'>
                      {vm.buttonLabel ? (
                        <span className='text-3xs text-contrast text-opacity-50'>
                          ({vm.buttonLabel})
                        </span>
                      ) : null}
                      {(vm.animRolls || vm.rolls || []).map((r, rIdx) => {
                        const tokenFace = resolveFaceOverride(
                          vm.buttonConfig,
                          r,
                        );
                        const key = `${vm.rollKey || 'r'}-${rIdx}`;
                        return (
                          <React.Fragment key={key}>
                            {rIdx > 0 ? (
                              <span className='text-3xs text-contrast text-opacity-40'>
                                +
                              </span>
                            ) : null}
                            {renderRollToken(r, tokenFace, item, key)}
                          </React.Fragment>
                        );
                      })}
                    </span>
                  ) : Number.isFinite(vm.value) ? (
                    <span className='flex items-center gap-03 justify-end'>
                      {vm.buttonLabel ? (
                        <span className='text-3xs text-contrast text-opacity-50'>
                          ({vm.buttonLabel})
                        </span>
                      ) : null}
                      {renderRollToken(vm.value, vm.face, item, vm.rollKey)}
                    </span>
                  ) : (
                    '-'
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
